"use client";
import { jsx as r } from "react/jsx-runtime";
import { withCmsDataHandling as y } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import u from "../../layout/Container/Container.js";
import { Video as M, sharedHandler as P } from "@ingeniorforeningen/figurine-core";
import { forwardRef as v } from "react";
import { mediaDeliveryApiParser as N } from "./Media.helpers.js";
import '../../../assets/Media.css';const _ = "_root_beso1_2", h = {
  root: _
}, o = v((e, t) => {
  const { ratio: s, allowFullscreen: a, controls: i, title: m, src: l, poster: d, loop: n, muted: p, autoPlay: c, ...f } = e;
  return /* @__PURE__ */ r(u, { ref: t, ...f, size: "sm", children: /* @__PURE__ */ r(M, { ...{
    ratio: s,
    allowFullscreen: a,
    controls: i,
    title: m,
    src: l,
    poster: d,
    loop: n,
    muted: p,
    autoPlay: c
  }, className: h.root }) });
});
o.displayName = "Media";
const w = y({
  Component: P(o),
  deliveryApiParser: N
});
w.displayName = o.displayName;
export {
  h as M,
  o as _Media,
  w as default
};
